import { render, staticRenderFns } from "./cdmapprove.vue?vue&type=template&id=96d9387c&"
import script from "./cdmapprove.vue?vue&type=script&lang=js&"
export * from "./cdmapprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports